import { createEnum } from "@redotech/zod-util/zod-enum";

export enum FlushReason {
  LIQUIDATE = "liquidate",
  DONATE = "donate",
  DESTROY = "destroy",
}

export const FlushReasonSchema = createEnum(FlushReason, {
  enumName: "FlushReason",
});

export const FLUSH_BIN_NAMES: Record<FlushReason, string> = {
  [FlushReason.LIQUIDATE]: "FLUSH_LIQUIDATE",
  [FlushReason.DONATE]: "FLUSH_DONATE",
  [FlushReason.DESTROY]: "FLUSH_DESTROY",
};

export enum FlushPickStrategy {
  /** The operator scans whatever they choose to flush. */
  MANUAL = "manual",
  /** Strict-scan teams: lists and only accepts units tagged for the reason. */
  OUTCOME = "outcome",
}

export const FlushPickStrategySchema = createEnum(FlushPickStrategy, {
  enumName: "FlushPickStrategy",
});

/**
 * A merchant's donate or destroy items are suggested for a flush once any of
 * them is older than this. Policy, not configuration.
 */
export const SUGGESTED_FLUSH_AGE_DAYS = 30;

/**
 * A liquidation may take every merchant's items at once. Other flushes stay
 * scoped to one merchant.
 */
export function allowsAllMerchantsFlush(reason: FlushReason): boolean {
  return reason === FlushReason.LIQUIDATE;
}

/** Liquidation carries money, so it is never suggested. */
export const SUGGESTED_FLUSH_REASONS: readonly FlushReason[] = [
  FlushReason.DONATE,
  FlushReason.DESTROY,
];
